import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  cardInner: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("lg")]: {
      textAlign: "center",
    },
  },
  title: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  subtitle: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  contactSupportButton: {
    marginTop: theme.spacing(3),
  },
}));
